import instance from "../../utils/axios"; // path to your axios file

// Fetch All or by ID
export const fetchChurches = async (payload = {}) => {
  const formData = new URLSearchParams();
  Object.entries(payload).forEach(([key, val]) => {
    if (val !== undefined && val !== null) {
      formData.append(key, val);
    }
  });
  if (!formData.has("typeofentity")) {
    formData.append("typeofentity", "1");
  }

  const response = await instance.post("/churches/readcms", formData);
  return response.data;
};


// Save Church
export const saveChurch = async (churchInputs) => {
  const formData = new URLSearchParams();
  Object.entries(churchInputs || {}).forEach(([key, val]) =>
    formData.append(key, val || "")
  );

  const response = await instance.post("/churches/save", formData);
  return response.data;
};

// Delete Church
export const deleteChurch = async (_id) => {
  const formData = new URLSearchParams();
  formData.append("_id", _id);

  const response = await instance.post("/churches/delete", formData);
  return response.data;
};

// Update Church
export const updateChurch = async (churchInputs) => {
  const formData = new URLSearchParams();
  Object.entries(churchInputs || {}).forEach(([key, val]) =>
    formData.append(key, val || "")
  );

  const response = await instance.post("/churches/update", formData);
  return response.data;
};

export const assignChurchAdmin = async (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) => {
    if (val !== undefined && val !== null) {
      formData.append(key, val);
    }
  });

  const response = await instance.post("/churches/admin/assign", formData);
  return response.data;
};

// Fetch by ID
export const fetchChurchById = async (_id) => {
  const formData = new URLSearchParams();
  formData.append("typeofentity", "1");
  formData.append("_id", _id);
  const response = await instance.post("/churches/readcms", formData);
  return response.data;
};
